import React from 'react';
import { useStyles } from './styles';

const CounterLeads = (props) => {
  const classes = useStyles();

  const {
    totalLeads,
    completosIntegrados,
    completosNoIntegrados,
    qtyLeads
  } = props;

  return (
    <>
      <p className={classes.totalLeads}>
        { totalLeads }
        {' '}
        Registros {'>'}
        {' '}
        { completosIntegrados }
        {' '}
        Registros Integrados {'>'}
        {' '}
        { completosNoIntegrados }
        {' '}
        Registros No Integrados
      </p>

      <p className={classes.totalLeads}>
        { qtyLeads &&
            <p><strong>{qtyLeads} Leads Seleccionados para integrar</strong></p>
        }
      </p>
    </>
  );
};

export default CounterLeads;
